export function mergeChunks(chunks) {
    const result = {};
  
    chunks.forEach((chunk) => {
      chunk.items_list.forEach((item) => {
        const dstItem = result[item.item_id];
        if (dstItem) {
          dstItem.trash = item.trash;
          return item.fields.forEach((srcField) => {
            let isFieldNonExist = true;
            dstItem.fields = dstItem.fields.map((dstField) => {
              if (Number(dstField.field_id) === Number(srcField.field_id)) {
                isFieldNonExist = false;
                if (dstField.field_value != srcField.field_value) {
                  return {
                    ...srcField,
                    history: srcField.history.concat(dstField.history),
                  };
                }
                return dstField;
              }
              return dstField;
            });
            if (isFieldNonExist) dstItem.fields.push(srcField);
          });
        }
        return (result[item.item_id] = item);
      });
    });
    return Object.values(result);
  }


self.onmessage = function(e) {      
    const mergedChunks = mergeChunks(e.data);
    self.postMessage(mergedChunks);
}


export function mergeChunksWorker() {
  return `function mergeChunks(chunks) {
    const result = {};
  
    chunks.forEach((chunk) => {
      chunk.items_list.forEach((item) => {
        const dstItem = result[item.item_id];
        if (dstItem) {
          dstItem.trash = item.trash;
          return item.fields.forEach((srcField) => {
            let isFieldNonExist = true;
            dstItem.fields = dstItem.fields.map((dstField) => {
              if (Number(dstField.field_id) === Number(srcField.field_id)) {
                isFieldNonExist = false;
                if (dstField.field_value != srcField.field_value) {
                  return {
                    ...srcField,
                    history: srcField.history.concat(dstField.history),
                  };
                }
                return dstField;
              }
              return dstField;
            });
            if (isFieldNonExist) dstItem.fields.push(srcField);
          });
        }
        return (result[item.item_id] = item);
      });
    });
    return Object.values(result);
  }


  self.onmessage = function(e) {      
    const mergedChunks = mergeChunks(e.data);
    self.postMessage(mergedChunks);
  }`;
}
